import React from 'react';
import Icon from '../../../AppIcon';

const OfflineIndicator = ({ isOnline, pendingSync, lastSyncTime }) => {
  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 bg-warning text-warning-foreground p-3 rounded-lg shadow-lg border border-warning/20">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          <Icon name="WifiOff" size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium">Working Offline</p>
              <p className="text-xs opacity-90">
                {pendingSync > 0 
                  ? `${pendingSync} items will sync when online`
                  : 'All data saved locally'
                }
              </p>
            </div>
            {lastSyncTime && (
              <div className="text-xs opacity-75">
                Last sync: {lastSyncTime}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineIndicator;